import React, { useState } from 'react';
import { Waves, Thermometer, ShieldAlert, CheckCircle2, Activity } from 'lucide-react';

export const HydrotherapyModule: React.FC = () => {
  const [waterTemp, setWaterTemp] = useState(34.5); // Celsius
  const [buoyancyPct, setBuoyancyPct] = useState(60); // % weight-bearing reduction

  return (
    <div className="p-6 space-y-6 bg-slate-900 text-white rounded-2xl">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-slate-800 pb-4">
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-cyan-500/20 text-cyan-300 text-xs font-bold rounded-full border border-cyan-500/30">
            <Waves className="w-3.5 h-3.5" /> Module 21: Hydrotherapy & Aquatic Physical Therapy
          </div>
          <h2 className="text-2xl font-black mt-2">Aquatic Pool Temperature & Buoyancy Rehab Engine</h2>
        </div>
        <div className="text-right">
          <div className="text-2xl font-black text-cyan-400 font-mono">{waterTemp}°C</div>
          <div className="text-xs text-slate-400">Target Pool Temperature</div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-slate-950 p-5 rounded-2xl border border-slate-800 space-y-4">
          <h3 className="text-sm font-bold text-slate-200 flex items-center gap-2">
            <Thermometer className="w-4 h-4 text-cyan-400" /> Pool Water Temperature Monitor
          </h3>
          <div className="space-y-2">
            <div className="flex justify-between text-xs text-slate-400">
              <span>Therapeutic Range (33°C - 36°C)</span>
              <span className="font-bold text-white">{waterTemp}°C</span>
            </div>
            <input 
              type="range" min="30" max="38" step="0.5"
              value={waterTemp} onChange={(e) => setWaterTemp(parseFloat(e.target.value))}
              className="w-full accent-cyan-500 cursor-pointer"
            />
          </div>
        </div>

        <div className="bg-slate-950 p-5 rounded-2xl border border-slate-800 space-y-4">
          <h3 className="text-sm font-bold text-slate-200 flex items-center gap-2">
            <Activity className="w-4 h-4 text-emerald-400" /> Aquatic Buoyancy Weight Reduction
          </h3>
          <div className="space-y-2">
            <div className="flex justify-between text-xs text-slate-400">
              <span>Chest Depth Weight Offloading</span>
              <span className="font-bold text-emerald-400">{buoyancyPct}% Reduced</span>
            </div>
            <input 
              type="range" min="20" max="90" step="5"
              value={buoyancyPct} onChange={(e) => setBuoyancyPct(parseInt(e.target.value))}
              className="w-full accent-emerald-500 cursor-pointer"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
